import type { ReactNode } from 'react';

export type BulkEditProviderPropTypes = {
  children: ReactNode;
};

export enum BulkEditOption {
  CardPermissions = 'cardPermissions',
  Tags = 'tags',
  Delete = 'delete',
}

export type BulkEditContextType = {
  isActive: boolean;
  activeOption: BulkEditOption | null;
};

export type BulkEditOptionsContextType = BulkEditContextType & {
  options: Set<BulkEditOption>;
  setActiveOption: (option: BulkEditOption) => void;
};
